import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import NavMenu from '../NavMenu/NavMenu';
import MenuButton from './MenuButton';
import EnvBadge from '../EnvBadge';
import Avatar from '../Avatar/Avatar';
import { PeikkoContext } from '../../contexts/PeikkoContext';

const HeaderContainer = styled.div`
  position: sticky;
  margin: 0 auto;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  padding: 26px 0;
`;

const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 25px;
`;

// Right-aligned cluster: the env letters sit immediately to the left of the
// menu icon (ActionContainer uses space-between, so this whole group hugs the
// right edge).
const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

interface HeaderProps {
  user: User;
  token?: string;
  isNativeShell?: boolean;
  gdprConsentGiven?: string;
}

const Header = ({
  user,
  token,
  isNativeShell,
  gdprConsentGiven,
}: HeaderProps): React.ReactElement => {
  const [showNavMenu, setShowNavMenu] = useState(false);
  const { showHeaderLogo } = useContext(PeikkoContext);
  return (
    <HeaderContainer role="navigation">
      <ActionContainer>
        {showHeaderLogo ? <Avatar width={70} height={70} /> : <div />}
        <HeaderActions>
          <EnvBadge />
          <MenuButton onClick={() => setShowNavMenu(!showNavMenu)} />
        </HeaderActions>
        <NavMenu
          isOpen={showNavMenu}
          closeMenu={() => setShowNavMenu(false)}
          user={user}
          token={token}
          isNativeShell={isNativeShell}
          gdprConsentGiven={gdprConsentGiven}
        />
      </ActionContainer>
    </HeaderContainer>
  );
};

export default Header;
